import { updateObject } from './../../utils/utility';
import { parse, formatISO } from 'date-fns'
const initialState = {
    savedSurveys: [],
    companies: [],
    hasServerResponded: false,
    surveyDetails: {}
};


const setHasResponded = (state = initialState, action) => {
    return updateObject(state, {
        hasServerResponded: action.data,
    });
};

const setSurveys = (state = initialState, action) => {
    return updateObject(state, {
        savedSurveys: [...action.data].map((survey) => {
            let questionaire = survey.questionaire.map((questionData) => {
                let answerTypes = [];
                if (questionData.questionType === "rating") answerTypes.push("rating");
                if (questionData.questionType === "comment") answerTypes.push("comment");
                if (questionData.questionType === "both") answerTypes.push(...["rating", "comment"]);
                return {
                    question: questionData.question,
                    answerTypes
                }
            });
            return {
                ...survey,
                questionaire,
                surveyScheduledDate : survey.surveyScheduledDate ? new Date(survey.surveyScheduledDate).toISOString() : null
            }
        })
    });
};
const setSurveyDetails = (state = initialState, action) => {
    return updateObject(state, {
        surveyDetails: action.data
    });
};

const reducer = (state = initialState, action) => {
    if (action.type === "SET_HAS_SURVEYS_RESPONDED") {
        return setHasResponded(state, action)
    }
    if (action.type === "SET_SURVEYS_DATA") {
        return setSurveys(state, action)
    }
    if (action.type === "SET_SURVEY_DETAILS") {
        return setSurveyDetails(state, action)
    }
    return state;
};

export default reducer;
